import React from 'react';
import PropTypes from 'prop-types';
import { LoadingButtonWrapper } from './components/LoadingButtonStyles';
import { getLoadingText } from './utils/loadingButtonHelpers';
import Button from '../../atoms/Button';

const LoadingButton = ({
  loading,
  loadingText,
  children,
  fullWidth,
  ...buttonProps
}) => {
  const displayText = loading ? getLoadingText(loadingText, children) : children;

  return (
    <LoadingButtonWrapper fullWidth={fullWidth}>
      <Button
        loading={loading}
        {...buttonProps}
      >
        {displayText}
      </Button>
    </LoadingButtonWrapper>
  );
};

LoadingButton.propTypes = {
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
};

LoadingButton.defaultProps = {
  loading: false,
  loadingText: undefined,
  children: 'Confirmar',
  fullWidth: false,
};

export default LoadingButton;



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingButton/LoadingButton.jsx